"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outgoing = void 0;
var Outgoing;
(function (Outgoing) {
    Outgoing["Handshake"] = "Handshake";
    Outgoing["PlayerStateUpdate"] = "PlayerStateUpdate";
    Outgoing["PlayerJoinRoom"] = "PlayerJoinRoom";
    Outgoing["LobbyStateUpdate"] = "LobbyStateUpdate";
    Outgoing["RoomStateUpdate"] = "RoomStateUpdate";
    Outgoing["RevealRoomPlayerCard"] = "RevealRoomPlayerCard";
    Outgoing["RefreshRoomPlayerCards"] = "RefreshRoomPlayerCards";
    Outgoing["RoomStartDistribution"] = "RoomStartCardsDistribution";
    Outgoing["RoomPlayerPuttingCard"] = "RoomPlayerPuttingCard";
    Outgoing["RoomPlayerDrawCard"] = "RoomPlayerDrawCard";
    Outgoing["RoomPlayerDrawnCard"] = "RoomPlayerDrawnCard";
    Outgoing["RoomPlayerChooseColor"] = "RoomPlayerChooseColor";
    Outgoing["RoomPlayerAction"] = "RoomPlayerAction";
    Outgoing["RoomPlayersSwappedHands"] = "RoomPlayersSwappedHands";
    Outgoing["PlayPutCardSound"] = "PlayPutCardSound";
    Outgoing["RoomPlayerPutEmote"] = "RoomPlayerPutEmote";
    Outgoing["RoomChatMessageReceived"] = "RoomChatMessageReceived";
    Outgoing["RoomChatTypingReceived"] = "RoomChatTypingReceived";
    Outgoing["LobbyError"] = "LobbyError";
})(Outgoing || (exports.Outgoing = Outgoing = {}));
